module.exports = "/images/completed-form-icon.png?f07c092f3ee28a678e5e9a66354fa511";